module.exports = __webpack_public_path__ + "media/images/icons/data-transfer-download-688dc7d1ecf1e7b885ecfc8074d3c52a.svg";